export { default } from "./SendWelcomeMail";



// WEBPACK FOOTER //
// ./src/mutations/SendWelcomeMail/index.ts